var Enum = Enum || {};

Enum.MDX_FILE_TYPE = {
    ORDER_FILES: 'ORDER_FILES',
    PRODUCT_FILES: 'PRODUCT_FILES',
    CLAIM_FILES: 'CLAIM_FILES',
    GUIDELINE_FILES: 'GUIDELINE_FILES',
    MERGED_ORDER_FILES: 'MERGED_ORDER_FILES',
    MERGED_PRODUCT_FILES: 'MERGED_PRODUCT_FILES',
    MERGED_CLAIM_FILES: 'MERGED_CLAIM_FILES',
    ZIP_ARCHIVE_EVENT_FILES: 'ZIP_ARCHIVE_EVENT_FILES',
    CLAIM_IMPORT_FILES: 'CLAIM_IMPORT_FILES',
    VERSION_ORDER_FILES: 'VERSION_ORDER_FILES'
};

Object.freeze(Enum.MDX_FILE_TYPE);